import React from 'react'

const None = ({ msg }) => (
  <div className="jumbotron">
    <h1>{msg}</h1>
  </div>
)

export default None



// WEBPACK FOOTER //
// ./src/containers/Billing/none.js